export default "__VITE_ASSET__Bn$DPo78__"